import { addLineItemToTape } from '@st/document-components/annotations'
import type { CalculatorTapeAnnotation } from '@st/sdk'

export function applyCalculatorTapeGridInput(
  annotation: CalculatorTapeAnnotation,
  inputValue: string,
  buttonValue: string
) {
  if (buttonValue != '=' && buttonValue != '+' && buttonValue != '-') {
    return { inputValue: inputValue + buttonValue }
  }

  if (buttonValue == '-' && inputValue.trim() == '') return { inputValue: '-' }

  const annotationDraft = addLineItemToTape(annotation, inputValue)
  if (annotationDraft == annotation) return { inputValue }

  return { annotationDraft, inputValue: buttonValue == '-' ? '-' : '' }
}
